// @flow

import { getProductType } from '../pdb/selectors';
import type { ProductTypeSettings } from '../../types';
import { getEntries } from '../../helpers';
import type { State as RouterState } from '../router/types';

type GlobalState = {
  pdb: any,
  productTypeSettings: ProductTypeSettings,
  router: RouterState,
};

type ProductTypeLabels = {
  [string]: string,
};

const getReducer = (state: GlobalState): ProductTypeSettings => state.productTypeSettings;

export const getProductTypeSetting = (state: GlobalState, productType: string): any => (
  getReducer(state)[productType]
);

export const getMileageDisplayType = (state: GlobalState, pdbId: ?string = null): string => (
  getProductTypeSetting(state, getProductType(state, pdbId)).config_mileage_package_display_type
);

export const getCartMileageDisplayType = (state: GlobalState, pdbId: ?string = null): string => (
  getProductTypeSetting(
    state,
    getProductType(state, pdbId),
  ).cart_config_mileage_package_display_type
);

export const getHideMileageLabel = (state: GlobalState, pdbId: ?string = null): boolean => (
  getProductTypeSetting(
    state,
    getProductType(state, pdbId),
  ).hide_mileage_label
);

export const getMileageLabel = (state: GlobalState, pdbId: ?string = null): string => (
  getProductTypeSetting(state, getProductType(state, pdbId)).mileage_label
);

export const getProductTypeLabel = (state: GlobalState, pdbId: ?string = null): string => (
  getProductTypeSetting(state, getProductType(state, pdbId)).product_type_label
);

// returns an object with productTypes and their translation-labels
export const getAllProductTypeLabels = (state: GlobalState): ProductTypeLabels => (
  getEntries(getReducer(state)).reduce((acc, [productType, settings]) => ({
    ...acc,
    [productType]: settings.product_type_label,
  }), {})
);
